import * as React from 'react';
import ReactDOM from 'react-dom';

import CatalogViewPage from 'components/catalogs/pages/view/CatalogViewPage';

ReactDOM.render(<CatalogViewPage />, document.getElementById('catalog-app'));
